import { withPending, withRejected, withFulFilled } from './commons';
import { UPLOAD_SURVEYS, UPLOAD_SURVEYS_PROGRESS, UPLOAD_SURVEYS_MARK_AS_COMPLETED } from '../actions/upload';

// initial state
const INITIAL_STATE = {
  running: false,
  error: null,
  payload: {
    progress: 0,
    isCompleted: false,
  },
};

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  // upload file
  case withPending(UPLOAD_SURVEYS):
    return { ...state, running: true };
  case withRejected(UPLOAD_SURVEYS):
    return { ...state, running: false, error: action.payload };
  case withFulFilled(UPLOAD_SURVEYS):
    return {
      ...state,
      running: false,
      payload: { progress: 100, isCompleted: true },
    };
    // progress on upload
  case UPLOAD_SURVEYS_PROGRESS:
    return {
      ...state,
      running: false,
      payload: { ...action.payload.data, isCompleted: false },
    };
    // reseting
  case UPLOAD_SURVEYS_MARK_AS_COMPLETED: return INITIAL_STATE;
    // nothing
  default:
    return state;
  }
};

export default execute;
